import { Text, Stack } from "@chakra-ui/react";

export const ChackraDateRangeInHeader = () => {
  return (
    <Stack zIndex={"dropdown"}>
      <Text color="brand.dark" as="b">
        Not Implemented{" "}
      </Text>
    </Stack>
  );
};
